import React from "react";
import { useTranslation } from "react-i18next";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function GetStarted() {
  const { t } = useTranslation();
  UseScrollAnimation();

  return (
    <section className="relative py-[40px] bg-[#E9F1FF]">
      <div className="container f-col flex gap-[40px] justify-between items-center">
        <div className="w-100 w-[49%] al-cen h-full flex flex-col gap-[20px] justify-center">
          <div>
            <div className="js-scroll fade-btm font-29 text-[35px] text-[#0B2C3D] font-bold capitalize">
              {t("Do you want to own a property?")}
            </div>
            <div className="js-scroll fade-top font-18 text-[20px] text-[#B39359]">
              {t("Put your email and we will contact you")}
            </div>
          </div>
          <form className="flex items-center relative w-fit">
            <input
              className="w-350-px w-[400px] p-[14px] rounded-[4px] border border-gray-300 outline-none"
              type="email"
              placeholder={t("Enter Your Email here ...")}
            />
            <button
              className="ri-to-left p-[8px] bg-[#B39359] text-white font-bold rounded absolute right-2"
              type="submit"
            >
              {t("Get Started")}
            </button>
          </form>
        </div>
        <div className="w-100 w-[49%] h-[450px]">
          <img className="w-full h-full object-cover" src={require("../../assets/projects/Painite-5.jpg")} alt="" />
        </div>
      </div>
    </section>
  );
}
